import { Box } from "@mui/material";
import React from "react";

/**
 * Componente que renderiza contenido solo visible para lectores de pantalla
 * pero oculto visualmente para usuarios sin discapacidad visual
 *
 * @param {Object} props - Propiedades del componente
 * @param {React.ReactNode} props.children - Contenido a renderizar para lectores de pantalla
 * @param {Object} [props.sx] - Estilos adicionales
 */
const ScreenReaderOnly = ({ children, sx = {}, ...props }) => {
  return (
    <Box
      sx={{
        position: "absolute",
        width: "1px",
        height: "1px",
        padding: 0,
        margin: "-1px",
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        borderWidth: 0,
        ...sx,
      }}
      aria-live="polite"
      {...props}
    >
      {children}
    </Box>
  );
};

export default ScreenReaderOnly;
